export default __webpack_public_path__ + "locales/sl/EmptyView.json?hash=aaba31b3080eb4804468e606ad27a13a";